

import React, { useState, useEffect, useCallback, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logout } from "../../redux/actions/grievanceActions1";
import "../../styles/HeaderStyles.css";

const Header = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.grievances);
  const [isProfileMenuOpen, setIsProfileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  console.log("rolename", user);

  // Create refs to track if navigation is in progress
  const navigationInProgress = useRef(false);
  const menuRef = useRef(null);
  const avatarRef = useRef(null);

  const handleLogout = useCallback(
    (e) => {
      e.preventDefault();
      e.stopPropagation();
      dispatch(logout());
      navigate("/");
    },
    [dispatch, navigate]
  );



 

  const toggleProfileMenu = useCallback(
    (e) => {
      e.stopPropagation();
      setIsProfileMenuOpen(!isProfileMenuOpen);
    },
    [isProfileMenuOpen]
  );

  // Close menus when clicking outside
  const closeMenus = useCallback(
    (e) => {
      // If navigation is in progress, don't do anything
      if (navigationInProgress.current) {
        return;
      }

      // Check if click is within dropdown or avatar
      const clickedWithinMenu =
        menuRef.current && menuRef.current.contains(e.target);
      const clickedAvatar =
        avatarRef.current && avatarRef.current.contains(e.target);

      if (!clickedWithinMenu && !clickedAvatar && isProfileMenuOpen) {
        setIsProfileMenuOpen(false);
      }
    },
    [isProfileMenuOpen]
  );

  // Check for scroll to add shadow effect
  const handleScroll = useCallback(() => {
    if (window.scrollY > 10) {
      setScrolled(true);
    } else {
      setScrolled(false);
    }
  }, []);

  useEffect(() => {
    if (isProfileMenuOpen) {
      document.addEventListener("click", closeMenus);
    } else {
      document.removeEventListener("click", closeMenus);
    }
    return () => {
      document.removeEventListener("click", closeMenus);
    };
  }, [isProfileMenuOpen, closeMenus]);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [handleScroll]);

  // Get user role text directly from API data
  const getUserRoleText = () => {
    return user?.ROLE_NAME || "";
  };

  // Get user initial from USER_NAME
  const userInitial = user?.USER_NAME?.charAt(0).toUpperCase() || "";

  // Get role badge color based on role name or ID
  const getUserRoleBadgeColor = () => {
    const roleName = user?.ROLE_NAME || "";
    const roleId = parseInt(user?.ROLE_ID) || user?.role;
    
    // Check role name first
    if (roleName.includes("ARESA")) return "role-aresa";
    if (roleName.includes("ADMIN") || roleName.includes("Admin")) return "role-admin";
    if (roleName.includes("DGAR")) return "role-dgar";
    
    // Fallback to role ID
    switch (roleId) {
      case 2:
        return "role-aresa";
      case 3:
        return "role-admin";
      case 4:
        return "role-dgar";
      default:
        return "role-default";
    }
  };

  // Get the display name for the user
  const getUserDisplayName = () => {
    return user?.USER_NAME || "";
  };

  return (
    <header className={`main-header ${scrolled ? "scrolled" : ""}`}>
      <div className="header-container">
        {/* Left section with logo and title */}
        <div className="header-left">
          <div className="logo-container">
            <img
              src="/images/AR_logo.png"
              alt="Logo"
              className="header-logo"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src =
                  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'%3E%3Cpath fill='%23ffffff' d='M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 16h-2v-2h2v2zm0-4h-2V7h2v8z'/%3E%3C/svg%3E";
              }}
            />
            <h1 className="logo-text">SAMPARK SETU</h1>
          </div>
        </div>

        {/* Right section with user profile */}
        <div className="header-right">
          {/* User profile */}
          {user && (
            <div className="user-profile">
              <div
                className="avatar-container"
                onClick={toggleProfileMenu}
                ref={avatarRef}
              >
                {user.profilePic ? (
                  <img
                    src={user.profilePic}
                    alt="Profile"
                    className="user-avatar"
                  />
                ) : (
                  <div className="user-avatar-placeholder">{userInitial}</div>
                )}
                <span className="user-name">{''}</span>
                <i
                  className={`bi bi-chevron-down dropdown-arrow ${
                    isProfileMenuOpen ? "rotated" : ""
                  }`}
                ></i>
              </div>

              {/* Profile dropdown menu */}
              {isProfileMenuOpen && (
                <div
                  className="user-menu-dropdown"
                  onClick={(e) => e.stopPropagation()}
                  ref={menuRef}
                >
                  <div className="user-menu-header">
                    <div className="user-menu-avatar">
                      {user.profilePic ? (
                        <img src={user.profilePic} alt="Profile" />
                      ) : (
                        <div className="menu-avatar-placeholder">
                          {userInitial}
                        </div>
                      )}
                    </div>
                    <div className="user-menu-details">
                      <div className="user-menu-name">{getUserDisplayName()}</div>
                      <div
                        className={`user-menu-role ${getUserRoleBadgeColor()}`}
                      >
                        {getUserRoleText()}
                      </div>
                    </div>
                  </div>

                  <div className="user-menu-options">
                    {/* <button className="user-menu-option ripple" onClick={handleProfileClick}>
                      <i className="bi bi-person-fill"></i>
                      <span>Profile</span>
                    </button> */}

                    {/* <button className="user-menu-option ripple" onClick={handleSettingsClick}>
                      <i className="bi bi-gear-fill"></i>
                      <span>Settings</span>
                    </button> */}

                    {/* <div className="menu-divider"></div> */}

                    <button
                      className="user-menu-option user-menu-logout ripple"
                      onClick={handleLogout}
                    >
                      <i className="bi bi-box-arrow-right"></i>
                      <span>Logout</span>
                    </button>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default React.memo(Header);
